import React, { useEffect } from "react";
import { useHardCode } from "../../hooks";
import { useSelector } from "react-redux";
import "./all_Item_navigate_modal.css";

export const AllItemNavigateModal = ({ onRequestClose, otherItems }) => {
  const storeConfigState = useSelector((state) => state.storeSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const heading = isPureFemale
    ? PURE_FEMALE_TRANSLATION.all_item_navigate.exchange_with_other_items
    : storeConfigState?.themeConfig?.exchange_with_other_items;
  const description = isPureFemale
    ? PURE_FEMALE_TRANSLATION.all_item_navigate.desc
    : storeConfigState?.themeConfig?.exchange_redirection_message;
  const back_btn = isPureFemale
    ? PURE_FEMALE_TRANSLATION.all_item_navigate.back
    : storeConfigState?.themeConfig?.back_button_label;
  const proceed_btn = isPureFemale
    ? PURE_FEMALE_TRANSLATION.all_item_navigate.proceed
    : storeConfigState?.themeConfig?.proceed;
  useEffect(() => {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the modal when the Escape key is pressed
        onRequestClose();
      }
    }
    // Prevent scrolling
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = "visible";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);
  return (
    <div className="saara-all-item" id="all-item">
      <div className="saara-all-item-content">
        <div className="saara-all-item-heading">{heading}</div>
        <div className="saara-all-item-description">{description}</div>
      </div>
      <div className="saara-contact-info-btns">
        <div className="saara_btn__big_screen_new margin-right-20">
          <button
            className="saara_custom_btn btn__back saara_modal_button_back"
            onClick={onRequestClose}
          >
            {back_btn}
          </button>
          <button
            className="saara_custom_btn btn__submit saara_modal_button_submit"
            onClick={otherItems}
          >
            {proceed_btn}
          </button>
        </div>
      </div>
    </div>
  );
};
